import GroupAddIcon from '@mui/icons-material/GroupAdd';
import { makeObservable, observable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroQuantidadePartesAutoras extends Filtro {
    tipo = 'booleano';

    get label() {
        return 'Mais de uma parte autora';
    }

    getIconeFiltroRapido() {
        return <GroupAddIcon />;
    }

    filtroRapido = {
        valor: true
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            filtroRapido: observable
        });
    }

    getValorOpcao(registro) {
        if (this.store.mapaProcessosPartes) {
            let partesProcesso = this.store.mapaProcessosPartes[registro.processo.numeroCompleto];
            return partesProcesso?.quantidadePartesAutoras > 1;
        }
        return false;
    }

    getDescricao(valor) {
        return this.labelBooleanoSimNao(valor);
    }
}
